import {
    ComponentManager,
    ListViewViewModel,
    UIListener,
} from 'radpresentation.htmlclient.defaultviewextensions';
import { IListViewDTO } from 'coreframetypings/dto';

class LVReferentenUIListener extends UIListener
{
    private static readonly TitleErgName = 'ONV_LV_REFERENTEN_LV_ERGNAME';

    public override onBeforeListViewRender(context: ListViewViewModel, dto: IListViewDTO)
    {
        dto.ergNamePluralized = LVReferentenUIListener.TitleErgName;
    }
}

ComponentManager.setUIListener('LVReferentenUIListener', LVReferentenUIListener, 'ONVHTMLViewExtension');
